import React from "react";
import { Section, Eyebrow } from "@/components/domain/Bits";
import { Building2, Target, Heart, Users, MapPin, Clock, ShieldCheck } from "lucide-react";

export default function About() {
  return (
    <div>
      <Section className="py-14">
        <Eyebrow><Building2 className="h-3.5 w-3.5" />Sobre nosotros</Eyebrow>
        <h1 className="mt-4 max-w-2xl text-4xl font-bold tracking-tight text-slate-900">Una empresa construida sobre la confianza</h1>
        <p className="mt-4 max-w-2xl text-lg text-slate-600">Círculo Dorado nació en 2019 con una idea simple: los sorteos pueden ser transparentes, tecnológicos y verificables. Datos de demostración.</p>
      </Section>

      <Section className="pb-12">
        <div className="grid gap-6 lg:grid-cols-3">
          {[[Target, "Misión", "Operar sorteos con transparencia total, dando certeza a cada participante en cada paso."],
            [Heart, "Valores", "Honestidad, trazabilidad y cercanía. La confianza vende antes que el premio."],
            [ShieldCheck, "Compromiso", "Cuentas oficiales, resultados públicos y entrega documentada de cada premio."]].map(([Icon, t, d], i) => (
            <div key={i} className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm">
              <div className="grid h-10 w-10 place-items-center rounded-lg bg-blue-50 text-brand"><Icon className="h-5 w-5" /></div>
              <h3 className="mt-4 font-semibold text-slate-900">{t}</h3><p className="mt-1 text-sm text-slate-600">{d}</p>
            </div>
          ))}
        </div>
      </Section>

      <Section className="pb-20">
        <div className="grid gap-8 rounded-2xl border border-slate-200 bg-white p-8 shadow-sm lg:grid-cols-2">
          <img src="https://images.unsplash.com/photo-1497366216548-37526070297c?w=900&q=80" alt="Oficinas" className="h-full w-full rounded-xl object-cover" />
          <div>
            <h2 className="text-2xl font-bold tracking-tight text-slate-900">Nuestras oficinas</h2>
            <div className="mt-5 space-y-3 text-sm text-slate-600">
              <div className="flex items-center gap-2"><MapPin className="h-4 w-4 text-brand" />Av. Vallarta 1234, Guadalajara, Jalisco</div>
              <div className="flex items-center gap-2"><Clock className="h-4 w-4 text-brand" />Lunes a viernes, 9:00 – 18:00</div>
              <div className="flex items-center gap-2"><Users className="h-4 w-4 text-brand" />Equipo de 24 personas dedicadas a la operación</div>
            </div>
            <div className="mt-6 grid grid-cols-3 gap-4 border-t border-slate-100 pt-6">
              <div><div className="font-mono text-2xl font-bold text-slate-900">2019</div><div className="text-xs text-slate-500">Fundación</div></div>
              <div><div className="font-mono text-2xl font-bold text-slate-900">38</div><div className="text-xs text-slate-500">Sorteos</div></div>
              <div><div className="font-mono text-2xl font-bold text-slate-900">100%</div><div className="text-xs text-slate-500">Entregados</div></div>
            </div>
          </div>
        </div>
      </Section>
    </div>
  );
}
